// Meta Pixel (Facebook Pixel) - Tracking utility
// Pixel ID: 1533555504779048

const META_PIXEL_ID = '1533555504779048';

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}

/** Initialize Meta Pixel - call once on app load */
export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;

  // Meta Pixel base code
  (function (f: Window, b: Document, e: string, v: string) {
    const n = (f.fbq = function (...args: unknown[]) {
      // @ts-expect-error Meta Pixel internal
      n.callMethod ? n.callMethod(...args) : n.queue.push(args);
    });
    if (!f._fbq) f._fbq = n;
    // @ts-expect-error Meta Pixel internal
    n.push = n;
    // @ts-expect-error Meta Pixel internal
    n.loaded = true;
    // @ts-expect-error Meta Pixel internal
    n.version = '2.0';
    // @ts-expect-error Meta Pixel internal
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** Track page view - call on route change */
export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
}

/** Track ViewContent - product page views */
export function trackViewContent(params: {
  content_name: string;
  content_ids: string[];
  content_type: string;
  value: number;
  currency: string;
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', params);
  }
}

/** Track AddToCart */
export function trackAddToCart(params: {
  content_name: string;
  content_ids: string[];
  content_type: string;
  value: number;
  currency: string;
  num_items: number;
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', params);
  }
}

/** Track InitiateCheckout */
export function trackInitiateCheckout(params: {
  content_ids: string[];
  content_type: string;
  value: number;
  currency: string;
  num_items: number;
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', params);
  }
}

/** Track Purchase with optional event_id for deduplication */
export function trackPurchase(params: {
  content_ids: string[];
  content_type: string;
  value: number;
  currency: string;
  num_items: number;
}, eventId?: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    if (eventId) {
      window.fbq('track', 'Purchase', params, { eventID: eventId });
    } else {
      window.fbq('track', 'Purchase', params);
    }
  }
}

/** Track custom events */
export function trackCustomEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', event, params);
  }
}
